import React, { Fragment, Component } from "react";
import Carousal from '../../../../components/Carousal';

const clients = [
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/sbi.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Indusind-bank.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/KVB.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Profectus-capital.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Kotra.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Cleartax.png?v=1",

  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Db-bank.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/ICRA.png?v=1",
  },

  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Central-bank-of-india.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Baritone-capital-advisory.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Avendus.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Sundaram-finance.png?v=1",
  },
  {
    image:
      "https://cdn.crediwatch.com/assets/images/public-home/clients/Aditya-birla-finance.png?v=1",
  },
];

export default class ClientScroll extends Component {
  render() {
    let settings = {
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            centerMode: true
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <Fragment>
        <h5 className="mb-3 text-center ff-renner-book">
          Trusted by 50+ enterprises & 13,000 Businesses
        </h5>
        <Carousal settings={settings}>
          {clients.map((each, index) => {
            return (
              <>
                <div>
                  <div className=" bg-white slider-item mt-3">
                    <div>
                      <img
                        className="mb-2 w-100"
                        src={each.image}
                        alt="Card image cap"
                      />
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </Carousal>
      </Fragment>
    );
  }
}
